import React, { useContext } from "react";
import { Checkbox, Popover } from "antd";
import { AppContext } from "../../context";
import { BsQuestionCircleFill } from "react-icons/bs";

function ImmediateConfirmation(props) {
  const info = useContext(AppContext);

  return (
    <>
      <Checkbox
        style={{ marginTop: 5 }}
        onChange={(e) => info.setImmediateConfirmation(e.target.checked)}
      >
        {info.t("immediate_response")}
      </Checkbox>
      <Popover
        content={<div>{info.t("immediate_response_businesses")}</div>}
        trigger="click"
      >
        <BsQuestionCircleFill style={{ marginTop: 8, cursor: "pointer" }} />
      </Popover>
    </>
  );
}

export default ImmediateConfirmation;
